import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { filter, map, mergeMap } from 'rxjs/operators';
import { environment } from 'src/environments/environment';
import { AuthenticationService } from './com/copeagenda/view/login/authentication/authentication.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent implements OnInit {
  title = 'CopeAgenda';

  isPagInicial: boolean = false;

  classDiv: string = '';

  containerIndex: string = '';

  showMenu: boolean = false;

  usuarioLogado: string | null = '';

  constructor(private router: Router, private activatedRoute: ActivatedRoute,
    private authenticationService: AuthenticationService,
    private titleService: Title) { }

  ngOnInit() {

    this.setDocTitle(environment.appTitle);

    this.router.events.pipe(
      filter(events => events instanceof NavigationEnd),
      map(evt => this.activatedRoute),
      map(route => {
        while (route.firstChild) {
          route = route.firstChild;
        }
        return route;
      }))
      .pipe(
        filter(route => route.outlet === "primary"),
        mergeMap(route => route.data)
      ).subscribe(x => x.isPagInicial === true ?
        (this.classDiv = 'bg', this.isPagInicial = true) :
        (this.classDiv = '', this.isPagInicial = false))

    this.configurarMenu();
  }

  configurarMenu(): void {

    if (this.authenticationService.currentUserValue.token) {
      this.showMenu = true;
      this.usuarioLogado = this.authenticationService.currentUserValue.username;
    } else {
      this.showMenu = false;
    }
  }
  
  getCustomNavBar() {
    return environment.customNavBar;
  }

  getContainerIndex() {
    return environment.containerIndex;
  }

  getSystemVersion() {
    return environment.version;
  }

  setDocTitle(title: string) {
    this.titleService.setTitle(title);
  }

  getHeaderPath() {
    return environment.headerPath;
  }
}
